import DashboardLayout from "@/components/layout/DashboardLayout";
import { Truck } from "lucide-react";

const TRANSPORTER_IDS = [
  { carrier: "Sendtoo (Own Network)", id: "37AANCC5387L1ZV" },
  { carrier: "Delhivery", id: "06AAPCS9575E1ZR" },
  { carrier: "XB", id: "27AAGCB3904P2ZC" },
  { carrier: "DTDC", id: "88AAACD8017H1ZX" },
  { carrier: "Bluedart", id: "27AAACB044L1ZS" },
  { carrier: "DP World", id: "88AADCD1983D1ZS" },
  { carrier: "Movin", id: "88AAFCI7460Q1ZW" },
  { carrier: "ECOM", id: "03AADCE1344F1ZA" },
  { carrier: "Ekart LTL", id: "07AADCI8374D2ZH" },
  { carrier: "TCI Express", id: "06AADCT0663J4Z9" },
];

export default function TransporterIds() {
  return (
    <DashboardLayout>
      <div className="space-y-5">
        <div className="flex items-center gap-2">
          <Truck className="w-6 h-6 text-brand-500" />
          <h1 className="text-2xl font-bold text-slate-800">Transporter IDs</h1>
        </div>
        <p className="text-sm text-slate-500">
          Reference table for Part-A Eway Bill generation. Select the Transporter ID matching the carrier actually handling the shipment.
        </p>

        <div className="bg-white border border-slate-200 rounded-xl overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-slate-200 bg-slate-50 text-left text-slate-500">
                <th className="px-4 py-3 font-semibold">Carrier</th>
                <th className="px-4 py-3 font-semibold">Transporter ID</th>
              </tr>
            </thead>
            <tbody>
              {TRANSPORTER_IDS.map((row) => (
                <tr key={row.carrier} className="border-b border-slate-100 last:border-0 hover:bg-slate-50">
                  <td className="px-4 py-3 text-slate-800 font-medium">{row.carrier}</td>
                  <td className="px-4 py-3 font-mono text-slate-600">{row.id}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </DashboardLayout>
  );
}
